import { FunctionComponent, useState } from 'react';
import { MultipleOptionsTemplate } from '@templates';
import issueInfoData from './issueInfoData';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';
import { InformationBox } from '@molecules/*';
import { ErrorMessages } from '@types';
import { issueTypeSingleSelectionSchema } from '@shared/schemas';
import { parseZodErrors } from '@utils';
import { ZodError } from 'zod';

const title = 'What is the issue?';

export const IssueType: FunctionComponent = () => {
  const navigate = useNavigate();
  const { data, update, get } = usePlanningBreachStore();

  const [errorMessage, setErrorMessages] = useState<ErrorMessages[]>([]);

  const handleChange = (result: string) => {
    const issueId = issueInfoData.find((type) => type.title === result);
    update('issueType', issueId?.id ?? '');
    setErrorMessages([]);
  };

  const handleNext = () => {
    try {
      issueTypeSingleSelectionSchema.parse({
        issueType: get('issueType'),
      });
      navigate(RoutesList.PHOTO_UPLOAD);
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
        })),
      );
    }
  };

  const options = issueInfoData.map((type) => ({
    id: type.id,
    title: type.title,
    labelText: type.title,
    isDefault: type.id === get('issueType'),
    isLabelBold: false,
  }));

  const issueDescription = issueInfoData.find(
    (type) => type.id === get('issueType'),
  );

  const buttonNext = {
    onClick: handleNext,
    label: 'Next',
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.PLANNING_BREACH_HOME),
    label: 'Previous',
  };

  return (
    <div>
      <MultipleOptionsTemplate
        title={title}
        radioOptions={[
          {
            onChange: handleChange,
            options: options,
          },
        ]}
        errorMessages={errorMessage}
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
        onChange={handleChange}
      >
        {data?.issueType && (
          <InformationBox
            title={issueDescription?.title}
            infoText={issueDescription?.descriptionInfo}
            variant="info"
          />
        )}
      </MultipleOptionsTemplate>
    </div>
  );
};
